import React from 'react';
import 'loaders.css/loaders.css';
import { SpinnerLoaderType } from '../../Helpers/enums';

export const SpinnerLoader = ({ loaderType }) => {
  if (loaderType === SpinnerLoaderType.Small) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="spinner-border spinner-border-lg text-primary" role="status" />
      </div>
    );
  } else
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border spinner-border-lg text-primary" role="status" />
      </div>
    );
};
